import { render, staticRenderFns } from "./mu-icon.vue?vue&type=template&id=6ffbd282&"
import script from "./mu-icon.vue?vue&type=script&lang=js&"
export * from "./mu-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports